import React from 'react';
import '../../style/solicitorGroup.css'
import Dots from 'react-activity/lib/Dots';
import '../../style/dots.css';
import '../../style/formResponseMessage.css'
import Button from "../button";
import {
  calculateSpecWordDoc,
} from "../../helpers/questionsSpec/specWordDocument";
import {
  APPLICATION_FORM_FIELDS, LEGAL_ADVICE_TEXT, MEDICAL_EXPERT_FEES_ENUM,
} from "../../helpers/variables";
import CustomTable from "../General/customTable/CustomTable";
import { orderBy } from 'lodash';
import {readQuestionDisplaySettings} from "../../helpers/questions/functions";

const SolicitorGroupSpec = (props) => {
  const defaultMandatoryValue = 'Always';
  const defaultStringValue = "String; 255 characters max";
  const defaultCalendarValue = "String; \nAny YYYY-MM-DDTHH:MM:SS.SSSZ string, which is a valid datetime e.g. 1957-11-03T00:00:00.000Z";
  const defaultUploadValue = "File parameters specified in the ‘Attachments Data Sub-Structure’ section above";
  const columns = [
    {propertyName: "questionMachineName", header: "Name"},
    {
      propertyName: "questionName",
      header: "Equivalent question\nin web portal",
    },
    {
      propertyName: "isMandatory",
      header: "When is field required?",
    },
    {
      propertyName: "allowedValues",
      header: "Allowed values\n& format",
    }];
  const attachmentsColumns = [
    {propertyName: "questionMachineName", header: "Name"},
    {
      propertyName: "isMandatory",
      header: "When is field required?",
    },
    {
      propertyName: "allowedValues",
      header: "Allowed values & format",
    }];
  if(!
    (props.solicitorGroup.solicitors && props.questionsSpec.specDto &&
      props.questionsSpec.specDto.basicDataStructure && props.questionsSpec.questionsSpec &&
      props.questions
    )){
    return <Dots />
  }
  const groupCaseTypes = props.solicitorGroup.caseTypes;
  const questionsSpecForGroup = props.questionsSpec.questionsSpec;
  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  const opponentsConditions =
    questionsSpecForGroup.find(qs => qs.questionId === (props.questions
      .find(q => q.machineName === "OpponentName") && props.questions
      .find(q => q.machineName === "OpponentName").id)) ?
      questionsSpecForGroup.find(qs => qs.questionId === props.questions
        .find(q => q.machineName === "OpponentName").id).caseSubCaseTypeDtos
        .map((combination, index) => {
          const groupCase = groupCaseTypes
            .find(gc => gc.machineName === combination.caseTypeMachineName);
          const numberOfSubCaseTypesAvailable = groupCase.subCaseTypes.length;
          const numberOfSubCaseTypesForQuestion = questionsSpecForGroup.find(qs => qs.questionId === props.questions
            .find(q => q.machineName === "OpponentName").id).caseSubCaseTypeDtos
            .filter(cs => cs.caseTypeMachineName === combination.caseTypeMachineName &&
              cs.subCaseTypeMachineName !== null)
            .length;
          const finalOutput =  `${(numberOfSubCaseTypesAvailable !== numberOfSubCaseTypesForQuestion ||
            (index === 0 || questionsSpecForGroup.find(qs => qs.questionId === props.questions
              .find(q => q.machineName === "OpponentName").id).caseSubCaseTypeDtos[index-1].caseTypeMachineName !== combination.caseTypeMachineName)) ?
            `Case type = ${combination.caseTypeMachineName} ${ numberOfSubCaseTypesAvailable === numberOfSubCaseTypesForQuestion ?
              `,`:
              `and Sub case type = ${combination.subCaseTypeMachineName === null ? 'null' : combination.subCaseTypeMachineName},`
            }`:``}`;
          return finalOutput.slice(0, -1)
        })
        .join("\n• ") :
      'No';
  const medicalExpertFeesConditions = questionsSpecForGroup.find(qs => qs.questionId === (props.questions
    .find(q => q.machineName === "EstimateForMedicalExpertFees") && props.questions
    .find(q => q.machineName === "EstimateForMedicalExpertFees").id))  ?
    questionsSpecForGroup.find(qs => qs.questionId === props.questions
      .find(q => q.machineName === "EstimateForMedicalExpertFees").id).caseSubCaseTypeDtos
      .map((combination, index) => {
        const groupCase = groupCaseTypes
          .find(gc => gc.machineName === combination.caseTypeMachineName);
        const numberOfSubCaseTypesAvailable = groupCase.subCaseTypes.length;
        const numberOfSubCaseTypesForQuestion = questionsSpecForGroup.find(qs => qs.questionId === props.questions
          .find(q => q.machineName === "EstimateForMedicalExpertFees").id).caseSubCaseTypeDtos
          .filter(cs => cs.caseTypeMachineName === combination.caseTypeMachineName &&
            cs.subCaseTypeMachineName !== null)
          .length;
        const finalOutput =  `${(numberOfSubCaseTypesAvailable !== numberOfSubCaseTypesForQuestion ||
          (index === 0 || questionsSpecForGroup.find(qs => qs.questionId === props.questions
            .find(q => q.machineName === "EstimateForMedicalExpertFees").id).caseSubCaseTypeDtos[index-1].caseTypeMachineName !== combination.caseTypeMachineName)) ?
          `Case type = ${combination.caseTypeMachineName} ${ numberOfSubCaseTypesAvailable === numberOfSubCaseTypesForQuestion ?
            `,`:
            `and Sub case type = ${combination.subCaseTypeMachineName === null ? 'null' : combination.subCaseTypeMachineName},`
          }`:``}`;
        return finalOutput.slice(0, -1)
      })
      .join("\n• ") :
    'No';

     const checkHasSubCase=(subCaseId) =>{
      return subCaseId==null;
    }

  const questionsWithSubCases = props.questionsSpec.questionsSpec.filter(q=> !q.subCaseTypeIds.every(checkHasSubCase)).length!=0?true:false;
  const basicDataTableData = orderBy(Object.keys(props.questionsSpec.specDto.basicDataStructure)
    .filter(b => props.questionsSpec.specDto.basicDataStructure[b] !== null))
    .map(field => {
      const fieldData = APPLICATION_FORM_FIELDS[Object.keys(APPLICATION_FORM_FIELDS).filter(f => APPLICATION_FORM_FIELDS[f].fieldName === capitalize(field))];
      let mandatoryValue = fieldData.fakeQuestion.isStandard ? defaultMandatoryValue :
        (fieldData.fakeQuestion.machineName === 'workSourceName' ?
            (props.solicitorGroup.workSources.length > 0 ?
            (props.solicitorGroup.requiredWorkSource ?
            defaultMandatoryValue : "Optional") :
            'No' ):
            (
              fieldData.fakeQuestion.machineName === APPLICATION_FORM_FIELDS.APPLICATION_OPPONENTS.fakeQuestion.machineName ?
                'Required if...\n• ' + opponentsConditions : (
                fieldData.fakeQuestion.machineName === APPLICATION_FORM_FIELDS.APPLICATION_MEDICAL_EXPERT_FEES.fakeQuestion.machineName ?
                  'Required if...\n• ' + medicalExpertFeesConditions :
                  fieldData.fakeQuestion.condition))
        );
      if(mandatoryValue.substring(mandatoryValue.length - 2) === "• "){
        mandatoryValue = mandatoryValue.substring(0,mandatoryValue.length - 3);
      }
      return ({
        questionMachineName: fieldData.fieldName,
        questionName: fieldData.name,
        isMandatory: mandatoryValue,
        allowedValues: fieldData.fakeQuestion.inputType === 'drop down' ?
          (fieldData.fakeQuestion.machineName === 'caseType' ?
            `String, One of...\n• ${props.solicitorGroup.caseTypes.map(c => c.machineName).join('\n• ')}` :
            `String, One of...${
              props.solicitorGroup.caseTypes
                .map(c => c.subCaseTypes.map(s => '\n• ' + s.machineName).join(''))
                .join('')
            }`)
          :
          (fieldData.fakeQuestion.inputType === 'calendar' ? defaultCalendarValue :
            (fieldData.fakeQuestion.inputType === 'array' ?
                'This is an array of objects, each of which describes one instance; The structure of these objects is set out in the related section down below' :
                (fieldData.fakeQuestion.inputType === 'boolean' ? 'Boolean; One of…\n• True\n• False' :
                  defaultStringValue)
            )),
      })
    })
    .filter(question =>!questionsWithSubCases? question.questionMachineName!="SubCaseType":question)
    .filter(q => q.isMandatory !== 'No');
  const attachmentsDataTableData = Object.keys(props.questionsSpec.specDto.attachmentDataSubStructure)
    .filter(b => props.questionsSpec.specDto.attachmentDataSubStructure[b] !== null)
    .map(field =>  {
      return ({
        questionMachineName: field,
        isMandatory: field!=='questionMachineName'?defaultMandatoryValue: 'Conditional; \n '+props.questionsSpec.specDto.attachmentDataSubStructure[field].toString().split('\n')[1],
        allowedValues:field!=='questionMachineName'? props.questionsSpec.specDto.attachmentDataSubStructure[field].toString():
        props.questionsSpec.specDto.attachmentDataSubStructure[field].toString().split('\n')[0],
      })
    });
  const opponentsTableData = Object.keys(props.questionsSpec.specDto.opponentsSubStructure)
    .filter(b => props.questionsSpec.specDto.opponentsSubStructure[b] !== null)
    .map(field => {
      const opponentQuestions = props.questions.filter(q => q.machineName.includes('pponent'));
      return ({
        questionMachineName: field,
        questionName: opponentQuestions.find(o => o.machineName.toLowerCase().includes(field)) && opponentQuestions.find(o => o.machineName.toLowerCase().includes(field)).name,
        isMandatory: field === 'satisfied' ?
          'Required if...\n• insured = ' +
          (opponentQuestions.find(o => o.machineName.toLowerCase().includes('nsure')) &&
            opponentQuestions.find(o => o.machineName.toLowerCase().includes('nsure'))
              .options.filter(o => o.childQuestions.length > 0).map(o => o.machineName).join('\n• insured = ')):
          defaultMandatoryValue,
        allowedValues: field === 'name' ? defaultStringValue : 'String, one of...\n• ' +
          (opponentQuestions.find(o => o.machineName.toLowerCase().includes(field)) &&
            opponentQuestions.find(o => o.machineName.toLowerCase().includes(field)).options
              .map(o => o.machineName).join("\n• ")),
      })
    });
  const medicalExpertsTableData = Object.keys(props.questionsSpec.specDto.medicalExpertsSubStructure)
    .filter(b => props.questionsSpec.specDto.medicalExpertsSubStructure[b] !== null)
    .map(field => {
      return ({
        questionMachineName: field,
        questionName: MEDICAL_EXPERT_FEES_ENUM[capitalize(field)].name,
        isMandatory: defaultMandatoryValue,
        allowedValues: props.questionsSpec.specDto.medicalExpertsSubStructure[field] === 'text'?
          defaultStringValue :
          (props.questionsSpec.specDto.medicalExpertsSubStructure[field] === 1.11 ?
              'Any decimal, 19+4' :
              'String; One of…\n• ' +
              (props.breachCausationCp.options && props.breachCausationCp.options.map(o => o.machineName).join("\n• "))
          ),
      })
    });

  const questionsTableData = props.questions
    .filter(q => !q.machineName.includes("pponent") && !q.machineName.includes("edicalExpertFe"))
    .map(q => {
      let possibleValues = defaultStringValue;
      switch (q.inputType) {
        case 'drop down':
          possibleValues = 'String; One of...\n• ' + q.options.map(o => o.machineName).join("\n• ");
          break;
        case 'calendar':
          possibleValues = defaultCalendarValue;
          break;
        case 'upload':
          possibleValues = defaultUploadValue;
          break;
        default:
          break;
      }
      let mandatoryValue = "No";
      const currentQuestionFromSpec = questionsSpecForGroup.filter(qs => qs.questionId === q.id);
      if(q.isParent) {
        if (currentQuestionFromSpec.map(qs => qs.caseTypeIds).length > 0) {
          const arrayOfCaseSubCase = currentQuestionFromSpec
            .map(qs => qs.caseSubCaseTypeDtos
              .map((combination, index) => {
                const groupCase = groupCaseTypes
                  .find(gc => gc.machineName === combination.caseTypeMachineName);
                const numberOfSubCaseTypesAvailable = groupCase.subCaseTypes.length;
                const numberOfSubCaseTypesForQuestion = qs.caseSubCaseTypeDtos
                  .filter(cs => cs.caseTypeMachineName === combination.caseTypeMachineName &&
                    cs.subCaseTypeMachineName !== null)
                  .length;
                const finalOutput =  `${(numberOfSubCaseTypesAvailable !== numberOfSubCaseTypesForQuestion ||
                  (index === 0 || qs.caseSubCaseTypeDtos[index-1].caseTypeMachineName !== combination.caseTypeMachineName)) ?
                  `Case type = ${combination.caseTypeMachineName} ${ numberOfSubCaseTypesAvailable === numberOfSubCaseTypesForQuestion ?
                    `,`:
                    `and Sub case type = ${combination.subCaseTypeMachineName === null ? 'null' : combination.subCaseTypeMachineName},`
                  }`:``}`;
                return finalOutput.slice(0, -1)
              }).join("\n• ")
            );
          mandatoryValue = 'Required if...\n• ' + arrayOfCaseSubCase;
        }
      }
      else {
        const parentQuestion = props.questions
          .find(qs => qs.options && qs.options.length > 0 &&
            qs.options.filter(o => o.childQuestions && o.childQuestions.length > 0  &&
              o.childQuestions.filter(ch => ch.machineName === q.machineName).length > 0).length > 0);
       
        if(questionsSpecForGroup.filter(qs => qs.questionId ===parentQuestion.id).map(qs => qs.caseTypeIds).length > 0 ) {
          mandatoryValue = q.questionDisplaySettings!=null? `Required if... ` + readQuestionDisplaySettings(q.questionDisplaySettings,props.questions):(
          `Required if...\n• ${parentQuestion.machineName} = ${parentQuestion.options
            .filter(o => o.childQuestions.find(ch => ch.machineName === q.machineName)).map(o => o.machineName).join("\n• ")}`);
        }
        else if (parentQuestion.questionDisplaySettings != null) {
          const mainParent = props.questions
            .find(qs => qs.options && qs.options.length > 0 &&
              qs.options.filter(o => o.childQuestions && o.childQuestions.length > 0 &&
                o.childQuestions.filter(ch => ch.machineName === parentQuestion.machineName).length > 0).length > 0)
          if (questionsSpecForGroup.filter(qs => qs.questionId === mainParent.id).map(qs => qs.caseTypeIds).length > 0) {
            mandatoryValue = `Required if...\n• ${parentQuestion.machineName} = ${parentQuestion.options
              .filter(o => o.childQuestions.find(ch => ch.machineName === q.machineName)).map(o => o.machineName).join("\n• ")}`;
          }

        }
        else if (parentQuestion.questionDisplaySettings == null && 
          props.questions.find(qs => qs.options && qs.options.length > 0 &&
            qs.options.filter(o => o.childQuestions && o.childQuestions.length > 0 &&
              o.childQuestions.filter(ch => ch.machineName === parentQuestion.machineName).length > 0).length > 0)) 
              {
          const firstNestingLvlParent = props.questions
            .find(qs => qs.options && qs.options.length > 0 &&
              qs.options.filter(o => o.childQuestions && o.childQuestions.length > 0 &&
                o.childQuestions.filter(ch => ch.machineName === parentQuestion.machineName).length > 0).length > 0)

          if (firstNestingLvlParent.questionDisplaySettings != null && 
            props.questions.find(qs => qs.options && qs.options.length > 0 &&
              qs.options.filter(o => o.childQuestions && o.childQuestions.length > 0 &&
                o.childQuestions.filter(ch => ch.machineName === parentQuestion.machineName).length > 0).length > 0)) 
                {
                  
            const topLvlParent = props.questions
              .find(qs => qs.options && qs.options.length > 0 &&
                qs.options.filter(o => o.childQuestions && o.childQuestions.length > 0 &&
                  o.childQuestions.filter(ch => ch.machineName === firstNestingLvlParent.machineName).length > 0).length > 0)

            if (questionsSpecForGroup.filter(qs => qs.questionId === topLvlParent.id).map(qs => qs.caseTypeIds).length > 0)
             {
              mandatoryValue = `Required if...\n• ${parentQuestion.machineName} = ${parentQuestion.options
                .filter(o => o.childQuestions.find(ch => ch.machineName === q.machineName)).map(o => o.machineName).join("\n• ")}`;
            }
          }
        }

      }
      if(mandatoryValue.substring(mandatoryValue.length - 2) === "• "){
        mandatoryValue = mandatoryValue.substring(0,mandatoryValue.length - 3);
      }
      return (
        {
          questionMachineName: q.machineName,
          questionName: q.name,
          isMandatory: mandatoryValue,
          allowedValues: possibleValues

        }
      )})
    .filter(q => q.isMandatory !== 'No');

  return (
    <div className="col-sm-12">
      <h2 className="agents-list-title">
        {LEGAL_ADVICE_TEXT} Group spec
      </h2>
      <p> This applies to the following {LEGAL_ADVICE_TEXT.toLowerCase()} firms <br />
        {props.solicitorGroup.solicitors.map(s => s.lawsysFirm).join(", ")}
      </p>
      {/*<Button*/}
      {/*  clickHandler={() => pdfMake.createPdf(calculateSpecDoc({*/}
      {/*    partner,*/}
      {/*    columns,*/}
      {/*    attachmentsColumns,*/}
      {/*    questionsTableData,*/}
      {/*    basicDataTableData,*/}
      {/*    attachmentsDataTableData,*/}
      {/*    opponentsTableData,*/}
      {/*    medicalExpertsTableData*/}
      {/*  })).download("solicitorSpec")}*/}
      {/*  wrapper="btn-wrapper" btnType="button"*/}
      {/*  btnStyle={'btn btn-primary btn-xs sharp white'}*/}
      {/*  label="Download spec "/>*/}
      <Button
        clickHandler={() => calculateSpecWordDoc({
          columns,
          attachmentsColumns,
          questionsTableData,
          basicDataTableData,
          attachmentsDataTableData,
          opponentsTableData,
          medicalExpertsTableData
        })}
        wrapper="btn-wrapper" btnType="button"
        btnStyle={'btn btn-primary btn-xs sharp white'}
        label="Download spec "/>
      <h3>Basic data structure</h3>
      <CustomTable
        responsive
        striped
        columns={columns}
        data={basicDataTableData}
      />
      <h3>Attachments data sub-structure</h3>
      <CustomTable
        responsive
        striped
        columns={attachmentsColumns}
        data={attachmentsDataTableData}
      />
      <h3>Opponents data sub-structure</h3>
      <CustomTable
        responsive
        striped
        columns={columns}
        data={opponentsTableData}
      />
      <h3>Medical experts data sub-structure</h3>
      <CustomTable
        responsive
        striped
        columns={columns}
        data={medicalExpertsTableData}
      />
      <h3>Application answers data sub-structure</h3>
      <CustomTable
        responsive
        striped
        columns={columns}
        data={questionsTableData}
      />
    </div>
  )
};

export default SolicitorGroupSpec;
